import React, { useState } from 'react';
import { GoalTracker } from './components/GoalTracker';
import { MonthTotals } from './components/MonthTotals';
export function App() {
  const [view, setView] = useState<'daily' | 'monthly'>('daily');
  return <div className="min-h-screen w-full bg-[#f0f9f4] text-gray-900 selection:bg-emerald-200 selection:text-emerald-900" style={{
    fontFamily: "'Inter', sans-serif"
  }} data-id="element-0">
      {view === 'daily' ? <GoalTracker onNavigate={setView} data-id="element-1" /> : <MonthTotals onNavigate={setView} data-id="element-2" />}
    </div>;
}